/**
 * calculate-myseed
 */

// Module dependencies
import 'protons';

// Module template
import './_calculate-myseed.twig';

// All Vue widgets only execute on existence of DOM
import VueCalculateMyseed from 'lib/vue-widget/src/vue-calculate-myseed';

// Render Vue elements as soon as possible
if (document.getElementById('vue-calculate-myseed')) {
  VueCalculateMyseed('#vue-calculate-myseed');
}

export const name = 'calculate-myseed';
export function disable() {}
export function enable() {}
export default enable;
